/* eslint-disable react-perf/jsx-no-new-function-as-prop */
import { Group, Modal, Text } from "@mantine/core";
import { CellContext, ColumnDef, createColumnHelper } from "@tanstack/react-table";
import { useState } from "react";
import { textMapDesafios } from "@/src/routes/gestao-inovacao-page/ExportIdeias";
import { TDesafioProcessado } from "../hooks/useDesafiosRelatorio";

const columnHelper = createColumnHelper<TDesafioProcessado>();

/**
 * @param properties - Properties
 * @param titulo - Title
 * @returns - texto
 */
function GetTexto(properties: CellContext<TDesafioProcessado, string>, titulo: string) {
  const maxTexto = 150;
  const [opened, setOpened] = useState(false);
  const originalText = properties.getValue();
  if (!originalText) return null;

  const isTooLong = originalText.length > maxTexto;
  const truncatedText = isTooLong ? `${originalText.slice(0, maxTexto)} ...` : originalText;
  const handleOpen = () => {
    if (isTooLong) {
      setOpened(true);
    }
  };
  const handleClose = () => setOpened(false);
  return (
    <>
      <Group gap="xs" wrap="nowrap">
        <Text fz="sm" style={{ cursor: isTooLong ? "pointer" : "default" }} onClick={handleOpen}>
          {truncatedText}
        </Text>
      </Group>
      <Modal opened={opened} onClose={handleClose} title={titulo}>
        <Text>{originalText}</Text>
      </Modal>
    </>
  );
}

const columns: ColumnDef<TDesafioProcessado>[] = [
  columnHelper.accessor("titulo", {
    header: "Título",
    cell: (properties) => <Text fz="sm">{properties.getValue()}</Text>
  }),
  columnHelper.accessor("propositorNome", {
    header: "Autor(es)",
    cell: (properties) => <Text fz="sm">{properties.getValue()}</Text>
  }),
  columnHelper.accessor("descricao", {
    header: "Descrição",
    cell: (properties) => GetTexto(properties, "Descrição")
  }),
  columnHelper.accessor("objetivo", {
    header: "Objetivo",
    cell: (properties) => GetTexto(properties, "Objetivo")
  }),
  columnHelper.accessor("propositorEmail", {
    header: "Email Autor(es)",
    cell: (properties) => <Text fz="sm">{properties.getValue()}</Text>
  }),
  columnHelper.accessor("createdAt", {
    header: "Data Criação",
    cell: (properties) => <Text fz="sm">{properties.getValue()?.toLocaleDateString()}</Text>
  }),
  columnHelper.accessor("status", {
    header: "Status",
    cell: (properties) => <Text fz="sm">{textMapDesafios[properties.getValue()]}</Text>
  }),
  columnHelper.accessor("moedas", {
    header: "Moedas",
    cell: (properties) => <Text fz="sm">{properties.getValue()}</Text>
  }),
  columnHelper.accessor("primeiraImersao", {
    header: "Primeira Imersão",
    cell: (properties) => {
      const value = properties.getValue();
      return <Text fz="sm">{value ? new Intl.DateTimeFormat("pt-BR").format(value) : "-"}</Text>;
    }
  }),
  columnHelper.accessor("ultimaImersao", {
    header: "Última Imersão",
    cell: (properties) => {
      const value = properties.getValue();
      return <Text fz="sm">{value ? new Intl.DateTimeFormat("pt-BR").format(value) : "-"}</Text>;
    }
  })
];

export default columns;
